import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ZonesSubscriptionGroupsActions from '../actions/zones-subscription-groups.actions';
import * as ZonesSubscriptionGroupsApiActions from '../actions/zone-subscription-groups-api.actions';
import { LoadingBarState } from '@ngx-loading-bar/core/loading-bar.state';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ZoneGroupsService } from 'src/app/zones/services/zone-groups.service';

@Injectable()
export class ZoneGroupsEffects {

  getZonGroups$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ZonesSubscriptionGroupsActions.getZonesSubscriptionGroups.type),
      switchMap((action: any) => this._zoneGroupsService.getZoneGroups()
        .pipe(
          exhaustMap((data) => {
            return of(ZonesSubscriptionGroupsApiActions.getZoneSubscriptionGroupsSuccess({data: data}))
          }),
          catchError(error => of(ZonesSubscriptionGroupsApiActions.getZoneSubscriptionGroupsFailure({error})))
        )
      )
    )
  );

  createZonesSubscriptionGroup$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ZonesSubscriptionGroupsActions.createZoneSubscriptionGroup.type),
      tap(() => this._loader.start()),
      switchMap((action: any) => this._zoneGroupsService.createZoneGroup(action.data)
        .pipe(
          exhaustMap((zone) => {
            return of(ZonesSubscriptionGroupsApiActions.createZoneSubscriptionGroupSuccess({data: zone}))
          }),
          catchError(error => of(ZonesSubscriptionGroupsApiActions.createZoneSubscriptionGroupFailure({error}))),
          tap(() => this._loader.complete()),
        )
      )
    )
  );

  editZonesSubscriptionGroup$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ZonesSubscriptionGroupsActions.editZoneSubscriptionGroup.type),
      tap(() => this._loader.start()),
      switchMap((action: any) => this._zoneGroupsService.editZoneGroup(action.zoneId, action.zoneGroupId)
        .pipe(
          exhaustMap((zone) => {
            return of(ZonesSubscriptionGroupsApiActions.editZoneSubscriptionGroupSuccess({data: zone}));
          }),
          catchError(error => of(ZonesSubscriptionGroupsApiActions.editZoneSubscriptionGroupFailure({error}))),
          tap(() => this._loader.complete()),
        )
      )
    )
  );

  assignZoneToZoneSubscriptionGroup$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ZonesSubscriptionGroupsActions.assignZoneToGroup.type),
      tap(() => this._loader.start()),
      switchMap((action: any) => this._zoneGroupsService.assignZoneToGroup(action.zoneId, action.zoneGroupId)
        .pipe(
          exhaustMap((res) => of(ZonesSubscriptionGroupsApiActions.assignZoneToZoneSubscriptionGroupSuccess({data: res}))),
          catchError(error => of(ZonesSubscriptionGroupsApiActions.assignZoneToZoneSubscriptionGroupFailure({error}))),
          tap(() => this._loader.complete()),
        )
      )
    )
  );

  unassignZoneToZoneSubscriptionGroup$ = createEffect(() =>
  this._actions$.pipe(
    ofType(ZonesSubscriptionGroupsActions.unassignZoneToGroup.type),
    tap(() => this._loader.start()),
    switchMap((action: any) => this._zoneGroupsService.unassignZoneToGroup(action.zoneId, action.zoneGroupId)
      .pipe(
        exhaustMap((res) => of(ZonesSubscriptionGroupsApiActions.unassignZoneToZoneSubscriptionGroupSuccess({data: res}))),
        catchError(error => of(ZonesSubscriptionGroupsApiActions.unassignZoneToZoneSubscriptionGroupFailure({error}))),
        tap(() => this._loader.complete()),
      )
    )
  )
);

  // changeState$ = createEffect(() =>
  //   this._actions$.pipe(
  //     ofType(ZonesSubscriptionsActions.changeState.type),
  //     tap(() => this._loader.start()),
  //     switchMap((action: any) => this._zoneSubscriptionsService.changeState(action.data)
  //       .pipe(
  //         exhaustMap((res) => of(ZonesSubscriptionsApiActions.changeStateSuccess({data: res}))),
  //         catchError(error => of(ZonesSubscriptionsApiActions.changeStateFailure({error}))),
  //         tap(() => this._loader.complete()),
  //       )
  //     )
  //   )
  //);

  private _loader: LoadingBarState;

  constructor(
    private _actions$: Actions,
    private _zoneGroupsService: ZoneGroupsService,
    private _loadingBar: LoadingBarService
  ) {
    this._loader = this._loadingBar.useRef('main');
  }
}
